var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-card"},[_c('div',{staticClass:"image-container"},[_c('img',{attrs:{"src":_vm.image,"alt":_vm.title}})]),_c('div',{staticClass:"container"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.text))])])])}
var staticRenderFns = []

export { render, staticRenderFns }